<!--
  VideoEmbed — 그룹 동영상 주소 하나를 플레이어로 그린다 (docs/문제은행_시스템.md 「그룹 동영상 › 관리자 화면 대응」).
  YouTube 주소만 iframe 임베드로 재생한다(2026-10-13 결정, 우선 YouTube 만). 그 밖의 http(s) 주소(예전 데이터·다른 경로로 들어온 값)는
  플레이어 없이 안내와 링크만, http(s) 가 아닌 값은 아무것도 그리지 않는다 (utils/groupVideos.getVideoEmbed). 플레이어 아래에 주소 링크(새 창)를 같이 둔다.
  강사 화면 src/components/VideoEmbed.vue 와 같은 구성이고 색만 관리자 토큰이다.
-->
<template>
  <div class="video-embed" :class="`video-embed--${embed.kind}`">
    <template v-if="embed.kind !== 'invalid'">
      <div v-if="embed.kind === 'youtube'" class="video-embed__frame">
        <iframe
          :src="embed.src"
          :title="title"
          loading="lazy"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        />
      </div>
      <div v-else class="video-embed__unsupported">
        <i class="material-icons-round">smart_display</i>
        <span>YouTube 주소만 화면 안에서 재생합니다. 아래 링크로 여세요.</span>
      </div>
      <div class="video-embed__caption">
        <span class="video-embed__kind">{{ kindLabel }}</span>
        <a :href="embed.url" target="_blank" rel="noopener noreferrer" class="video-embed__link" @click.stop>
          <span class="video-embed__url">{{ embed.url }}</span>
          <i class="material-icons-round">open_in_new</i>
        </a>
      </div>
    </template>
  </div>
</template>

<script>
import { computed } from 'vue'
import { getVideoEmbed } from '@/utils/groupVideos'

const KIND_LABELS = { youtube: 'YouTube', link: '링크' }

export default {
  name: 'VideoEmbed',
  props: {
    url: { type: String, required: true },
    title: { type: String, default: '동영상' },
  },
  setup(props) {
    const embed = computed(() => getVideoEmbed(props.url))
    const kindLabel = computed(() => KIND_LABELS[embed.value.kind] || '')
    return { embed, kindLabel }
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/pineapple";

.video-embed {
  border: 1px solid $p-line-soft;
  border-radius: $p-radius-md;
  overflow: hidden;
  background: $p-panel;

  &--invalid { display: none; }

  /* 16:9 상자 — padding-top 방식 (aspect-ratio 미지원 브라우저 대비) */
  &__frame {
    position: relative;
    width: 100%;
    padding-top: 56.25%;
    background: #000;

    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: 0;
    }
  }
  &__unsupported {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 14px;
    font-size: 12px;
    color: $p-ink-mid;
    background: $p-bg;

    i { font-size: 20px; color: $p-ink-soft; flex-shrink: 0; }
  }
  &__caption {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 10px;
    border-top: 1px solid $p-line-soft;
    background: $p-bg;
    min-width: 0;
  }
  &__kind {
    flex-shrink: 0;
    padding: 1px 7px;
    border-radius: 999px;
    background: $p-point-soft;
    color: $p-point-deep;
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 0.04em;
  }
  &__link {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    min-width: 0;
    font-family: $p-font-mono;
    font-size: 11px;
    color: $p-info;
    text-decoration: underline;

    i { font-size: 13px; flex-shrink: 0; }
  }
  &__url {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
